import HiddenNav from '../../classes/HiddenNav';
import {Lightbox} from '../../classes/Lightbox';
const BREAKPOINT = 1024;

const initHeader = () => {
	const header = document.querySelector( 'body > header' );

	const nav = header.querySelector( 'div.menu' );
	const navContainer = header.querySelector( 'nav > ul' );
	const burgerBtn = header.querySelector( 'button.burger' );
	const burgerBtnClose = header.querySelector( 'button.burger-close' );
	const burger = header.querySelector( 'div.burger' );
	const leadButton = header.querySelector('div.lead-button > button');

	const hiddenNavInstance = new HiddenNav( navContainer );

	if ( !header )
	{
		return;
	}

	const checkScrollPosition = () => {
		if ( window.pageYOffset > 1 || !document.querySelector( 'body.index' ) )
		{
			header.classList.add( 'scroll' );
		}
		else
		{
			header.classList.remove( 'scroll' );
		}
	};

	checkScrollPosition();

	window.addEventListener( 'scroll', checkScrollPosition );

	const timeWrapper = header.querySelector( 'li.time > span:last-child' );

	if ( !timeWrapper )
	{
		return;
	}

	let nowDate = null;
	const options = {
		timeZone: 'Asia/Bangkok',
		hour: 'numeric',
		minute: 'numeric',
	};

	const getTime = () => {
		nowDate = new Date();

		const currentTime = nowDate.toLocaleString( 'ru-RU', options );

		timeWrapper.textContent = currentTime;
	};

	getTime();
	setInterval( getTime, 1000 );

	burgerBtn.addEventListener( 'click', () => {
		header.classList.add( 'burger-open' );

		document.querySelector( 'html' ).style.overflow = 'hidden';
	} );

	burgerBtnClose.addEventListener( 'click', () => {
		header.classList.remove( 'burger-open' );
		document.querySelector( 'html' ).style.overflow = '';
	} );

	burger.addEventListener( 'click', ( e ) => {
		const target = e.target;

		if ( target.closest( 'li.submenu' ) )
		{
			const currentTarget = target.closest( 'li.submenu' );

			const dataIndex = currentTarget.getAttribute( 'data-index' );
			const submenu = burger.querySelector( `ul[data-index="${dataIndex}"]` );

			burger.querySelectorAll( 'li.submenu.active' ).forEach( ( item ) => {
				item.classList.remove( 'active' );
			} );

			burger.querySelectorAll( 'ul.submenu' ).forEach( ( item ) => {
				item.style.display = 'none';
			} );

			submenu.style.display = 'flex';
			currentTarget.classList.add( 'active' );
		}
	} );

	leadButton.addEventListener( 'click', () => {
		fetch( '/ajax/?action=get-leadform', {
			method: 'POST',
			credentials: 'same-origin',
			headers: {
				'X-Requested-With': 'XMLHttpRequest',
				'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
			}
		} )
		.then( function( data ) {
			if ( !data.ok )
			{
				throw new Error( 'Could not fetch, status: ' + data.status );
			}

			return data.json();
		} )
		.then( function( response ) {
			Lightbox.open( response.rendered, null, 'lead-lightbox' );
		} );
	} )
};

export {
	initHeader,
};
